<template>
  <div class="issueadd" v-dragDiv v-show="addShow">
    <div class="addTitle moveDragDiv">
      <span>系统</span>
      <i class="el-icon-close" @click="closeArea"></i>
    </div>
    <div class="nav">
      <el-tree ref="tree" :expand-on-click-node="false" class="navTree" :data="datatree" :props="defaultProps" @node-click="nodeClick">
        <div slot-scope="{ node, data }" class="warp">
          <div v-if="!data.elementId" :title="node.label">{{node.label}}</div>
          <div v-else class="nodeRow" :title="node.label">
            <img v-show="isShowMark(data)" class="select" :src="require('./../images/空间系统选中.png')" alt="选中">
            <div class="name">{{node.label}}</div>
            <img v-show="isShowMark(data)" class="target" :src="require('./../images/定位.png')" alt="定位">
          </div>
        </div>
      </el-tree>
    </div>
  </div>
</template>

<script>
export default {
  name:'systemTree',
  data () {
    return {
      addShow:false,
      datatree:[],
      defaultProps:{
        children: "children",
        label: "label",
      },
      oldData:{}
    }
  },

  methods : {
    openArea(){
      if (!this.datatree[0]) {
        this.datatree = []
        this.datatree = Monge.Model.Tree.getSystemTree() || []
      }
      this.addShow = true;
    },

    closeArea(){
      this.addShow = false
    },

    isShowMark (data) {
      const {elementId} = data
      const {elementId:oldElementId} = this.oldData
      return elementId === oldElementId
    },

    nodeClick (data,node) {
      if (node.isLeaf && node.level !== 1) {
        const {modelId,elementId} = data
        const {elementId:oldElementId} = this.oldData
        if (elementId !== oldElementId) {
          Monge.Model.Selector.select(modelId, elementId)
          Monge.Model.Camera.fitToBox(modelId, elementId)
          this.oldData = data
        } else {
          Monge.Model.Selector.cancelSelect()
          Monge.Model.Camera.fitToHome(() => {

          })
          this.oldData = {}
        }
      }
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.issueadd {
  position: absolute;
  top: 65px;
  left: 151px;
  width: 300px;
  height: calc(100% - 190px);
  max-height: 770px;
  z-index: 5;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0px 0px 4px 1px rgba(46, 91, 255, 0.17);
  border-radius: 4px;
  .addTitle{
    cursor: move;
    width: 100%;
    height: 50px;
    padding: 0 15px;
    box-sizing: border-box;
    border-bottom: 1px solid #E8EBEF;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    user-select: none;
    span{
      font-size: 16px;
      font-weight: bold;
    }
    i{
      font-size: 16px;
      cursor: pointer;
    }
  }
  .nav{
    height calc(100% - 50px)
    overflow-y auto
    /deep/ .el-tree{
      .warp{
        width 100%
        .nodeRow{
          width 100%
          display flex
          align-items center
          position relative
          .select{
            position absolute
            left 0
            top 50%
            transform translateY(-50%)
          }
          .name{
            width 90%
            padding-left 10px
          }
        }
      }
      }
  }
}
</style>
